import { API_PATHS } from "@config/constants";

// Derive "front/" base from existing login path.
const API_ADMIN_BASE =
  typeof API_PATHS?.login === "string"
    ? API_PATHS.login.replace(/front\/login\/account\/?$/, "front/")
    : "";

// NOTE: These endpoints are best-effort guesses for compatibility with the cloned MiniGame module.
// If backend differs, the UI should still render; requests will fail gracefully via config/service.
const API_PATH = {
  // gameplay / spins
  miniGamePlayLoto: `${API_ADMIN_BASE}mini-game/play`,
  miniGamePlayLotoMultiple: `${API_ADMIN_BASE}mini-game/play-multiple`,
  miniGameSpinUser: `${API_ADMIN_BASE}mini-game/get-spin-user`,
  miniGameSpinHistory: `${API_ADMIN_BASE}mini-game/spin-history`,

  // missions / awards / ranking
  miniGameMissions: `${API_ADMIN_BASE}mini-game/missions`,
  miniGameAwardList: `${API_ADMIN_BASE}mini-game/get-award-list`,
  miniGameRanking: `${API_ADMIN_BASE}mini-game/get-ranking`,
  miniGameRules: `${API_ADMIN_BASE}mini-game/get-rule`,
  miniGamePrizeCollection: `${API_ADMIN_BASE}mini-game/prize-collection`,
  miniGameHistory: `${API_ADMIN_BASE}mini-game/history`,
  miniGameChangeAttempt: `${API_ADMIN_BASE}mini-game/change-attempt-by-bid`,
  miniGameLisWinner: `${API_ADMIN_BASE}mini-game/winner-list`,
  miniGameGetMiniGame: `${API_ADMIN_BASE}mini-game/get-mini-game`,
  miniGameListWinner: `${API_ADMIN_BASE}mini-game/list-winner`,

  // puzzle pieces / take prize
  miniGamePieceCollected: `${API_ADMIN_BASE}mini-game/piece-collected`,
  miniGameTakePrize: `${API_ADMIN_BASE}mini-game/take-prize`,

  // invite / give / request pieces
  miniGameAddInviteLink: `${API_ADMIN_BASE}mini-game/invite/add-link`,
  miniGameGetCodeInviteLinkInfo: `${API_ADMIN_BASE}mini-game/invite/code-info`,
  miniGameReceiveInviteLink: `${API_ADMIN_BASE}mini-game/invite/receive`,

  miniGameSendPieceLink: `${API_ADMIN_BASE}mini-game/piece/send-link`,
  miniGameReceivePieceLink: `${API_ADMIN_BASE}mini-game/piece/receive-link`,
  miniGameGetCodePieceLinkInfo: `${API_ADMIN_BASE}mini-game/piece/code-info`,

  miniGameDeleteReceiveGive: `${API_ADMIN_BASE}mini-game/piece/delete-receive-give`,

  // invite ranking pages
  miniGameInviteRanking: `${API_ADMIN_BASE}mini-game/invite/ranking`,
  miniGameWinnerInviteRanking: `${API_ADMIN_BASE}mini-game/invite/winner-ranking`,
};

export default API_PATH;

